export default __webpack_public_path__ + "static/media/squid.a1024bc3.webp";